import React, { useState } from 'react';
import { subscribeNewsletter } from '../../lib/api';
import { Mail, CheckCircle2, Loader2 } from 'lucide-react';

const NewsletterBox = ({ dark = false }) => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      const res = await subscribeNewsletter(email);
      setDone(res.message);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally { setBusy(false); }
  };

  const base = dark
    ? { wrap: 'bg-white/5 border-white/10 text-white', sub: 'text-slate-400', input: 'bg-white/10 border-white/10 text-white placeholder:text-slate-500' }
    : { wrap: 'bg-slate-950 border-slate-800 text-white', sub: 'text-slate-400', input: 'bg-white/10 border-white/10 text-white placeholder:text-slate-500' };

  return (
    <div className={`rounded-2xl border p-6 sm:p-8 ${base.wrap}`} data-testid="newsletter-box">
      {done ? (
        <div className="flex items-center gap-3" data-testid="newsletter-success">
          <CheckCircle2 className="h-8 w-8 text-emerald-400 shrink-0" />
          <div>
            <div className="font-extrabold">{done}</div>
            <div className={`text-sm ${base.sub}`}>No spam — practical insights only, about once a month.</div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex items-center gap-2 font-extrabold text-lg">
            <Mail className="h-5 w-5 text-orange-400" /> Get insights in your inbox
          </div>
          <p className={`mt-1.5 text-sm ${base.sub}`}>Practical guides on software, AI and growth — about once a month. No spam, unsubscribe anytime.</p>
          <form onSubmit={submit} className="mt-4 flex flex-col sm:flex-row gap-2">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              data-testid="newsletter-email-input"
              className={`flex-1 h-11 rounded-xl border px-4 text-sm outline-none focus:ring-2 focus:ring-orange-500 ${base.input}`}
            />
            <button
              type="submit"
              disabled={busy}
              data-testid="newsletter-subscribe-btn"
              className="h-11 px-6 rounded-xl bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold transition-colors inline-flex items-center justify-center gap-2"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Subscribe'}
            </button>
          </form>
          {error && <div className="mt-2 text-sm text-rose-400" data-testid="newsletter-error">{error}</div>}
        </>
      )}
    </div>
  );
};

export default NewsletterBox;
